import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { CheckmarkCircle } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { FeedbackPromptBar } from './FeedbackPromptBar';
import { UserActionStatus } from './UserActionStatus';
export const GetAppliedMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const AppliedMessage = (param)=>{
    let { content, messageId, showFollowUpSuggestions = true, onSuggestionClick, onSubmitFeedback, onDismissFeedback } = param;
    const { AppliedMessageTID } = useMemo(()=>GetAppliedMessageTID(messageId), [
        messageId
    ]);
    const { t } = useLocaleKeys();
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": AppliedMessageTID.Root(),
        children: [
            /*#__PURE__*/ _jsx(UserActionStatus, {
                Icon: CheckmarkCircle,
                iconSkin: "primary",
                text: t.agenticDrafting.messages.userApply(),
                testId: AppliedMessageTID.Summary()
            }),
            content.followUp != null && /*#__PURE__*/ _jsxs("div", {
                "data-testid": AppliedMessageTID.FollowUp(),
                children: [
                    content.followUp.text != null && /*#__PURE__*/ _jsx(Typography, {
                        testId: AppliedMessageTID.FollowUpText(),
                        children: content.followUp.text
                    }),
                    showFollowUpSuggestions && content.followUp.suggestions.length > 0 && /*#__PURE__*/ _jsx("div", {
                        "data-testid": AppliedMessageTID.FollowUpSuggestions(),
                        children: content.followUp.suggestions.map((suggestion, idx)=>/*#__PURE__*/ _jsx("button", {
                                type: "button",
                                "data-testid": AppliedMessageTID.FollowUpSuggestion(idx),
                                onClick: onSuggestionClick != null ? ()=>onSuggestionClick(suggestion) : undefined,
                                disabled: onSuggestionClick == null,
                                children: suggestion
                            }, idx))
                    })
                ]
            }),
            content.feedbackPrompt != null && onSubmitFeedback != null && onDismissFeedback != null && /*#__PURE__*/ _jsx(FeedbackPromptBar, {
                prompt: content.feedbackPrompt,
                onSubmit: onSubmitFeedback,
                onDismiss: onDismissFeedback,
                testId: messageId
            })
        ]
    });
};
